"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.gqlEndpoints = exports.EXCHANGE_SUBQL_ENDPOINTS = exports.AIRDROP_SUBQL_ENDPOINTS = exports.NETWORK_SUBQL_ENDPOINTS = exports.RPC_ENDPOINTS = exports.IPFS_URL = exports.IPFS_URLS = exports.GQLEndpoint = exports.SQNetworks = void 0;
var SQNetworks;
(function (SQNetworks) {
    SQNetworks["TESTNET"] = "testnet";
    SQNetworks["KEPLER"] = "kepler";
    SQNetworks["MAINNET"] = "mainnet";
})(SQNetworks = exports.SQNetworks || (exports.SQNetworks = {}));
var GQLEndpoint;
(function (GQLEndpoint) {
    GQLEndpoint["Network"] = "network";
    GQLEndpoint["Exchange"] = "exchange";
    GQLEndpoint["Airdrop"] = "airdrop";
})(GQLEndpoint = exports.GQLEndpoint || (exports.GQLEndpoint = {}));
exports.IPFS_URLS = {
    project: 'https://ipfs.subquery.network/ipfs/api/v0',
    metadata: 'https://interipfs.thechaindata.com/ipfs/api/v0',
};
exports.IPFS_URL = 'https://interipfs.thechaindata.com/ipfs/api/v0';
exports.RPC_ENDPOINTS = {
    mainnet: 'https://polygon-rpc.com/',
    kepler: 'https://polygon-rpc.com/',
    testnet: 'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78',
};
exports.NETWORK_SUBQL_ENDPOINTS = {
    mainnet: 'https://api.subquery.network/sq/subquery/kepler-network',
    kepler: 'https://api.subquery.network/sq/subquery/kepler-network',
    testnet: 'https://api.subquery.network/sq/subquery/kepler-testnet',
};
exports.AIRDROP_SUBQL_ENDPOINTS = {
    mainnet: 'https://api.subquery.network/sq/subquery/kepler-network-airdrop',
    kepler: 'https://api.subquery.network/sq/subquery/kepler-network-airdrop',
    testnet: 'https://api.subquery.network/sq/subquery/kepler-testnet-airdrop',
};
exports.EXCHANGE_SUBQL_ENDPOINTS = {
    mainnet: 'https://api.subquery.network/sq/subquery/kepler-network-exchange',
    kepler: 'https://api.subquery.network/sq/subquery/kepler-network-exchange',
    testnet: 'https://api.subquery.network/sq/subquery/kepler-testnet-exchange',
};
function gqlEndpoints(network) {
    return {
        [GQLEndpoint.Network]: exports.NETWORK_SUBQL_ENDPOINTS[network],
        [GQLEndpoint.Airdrop]: exports.AIRDROP_SUBQL_ENDPOINTS[network],
        [GQLEndpoint.Exchange]: exports.EXCHANGE_SUBQL_ENDPOINTS[network],
    };
}
exports.gqlEndpoints = gqlEndpoints;
//# sourceMappingURL=constants.js.map